import { Injectable } from '@angular/core';
import { AppConstants_Design } from '../AppConstants_Design.enum';

@Injectable({
  providedIn: 'root',
})
export class TenantsService {
  Active_StaffId:any;
  constructor() {}
  getTenantFromSubdomain(): string {
    const host = AppConstants_Design.COMPANYID; // window.location.hostname;
    const parts = host.split('.');
    if (parts.length < 3) {
      return 'default';
    }
    return parts[0];
  }
}
